import React, { useEffect, useState } from 'react';
import { fetchData, saveLogEvent } from '../utils/Utils';


const Contact = ({labels}) => {
    const [customerInfo, setCustomerInfo] = useState(null);

    useEffect(() => {
        fetchData()
            .then(data => {
                setCustomerInfo(data.data);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    }, []);

   useEffect(()=>{
        saveLogEvent({
                   logLevel: "info",
                   statusCode: 200,
                   status: "success",
                   message: {
                     Page:"Contact Page",
                     trigger: "On Load of Contact Page",
                   },
                   payload:{
                    Page:"Contact Page",
                     trigger: "On Load of Contact Page",
                   }
               });
     },[])
    

    const BM = customerInfo?.CustomerDetails?.Branch?.BM;
    const CRO = customerInfo?.CustomerDetails?.Branch?.CRO;
    const branch = customerInfo?.CustomerDetails?.Branch?.Name;
    return (
        <>
            <div className="font-bold mt-4 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-t-lg font-gotham-rounded fs-32w">{labels.helplineTitle}</div>
            <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
                <div className="grid grid-cols-2 gap-2">
                    <p className='leading-[1.65]'>{labels.customerHelpline}</p>
                    <a href={`tel:${labels.helplineNumber}`} className="text-end">{labels.helplineNumber}</a>
                </div>
            </div>
            <div className="font-bold mt-4 text-black  border-t border-r border-l bg-gray-300 p-3 rounded-t-lg fs-32w">{labels.branchTitle}</div>
            <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
                <div className="grid grid-cols-2 gap-2">
                    <div>{labels.branch}</div>
                    <div className="text-end">{branch}</div>
                    <div>{labels.branchManager}</div>
                    <div className="text-end">{BM?.Name}</div>
                    <div>{labels.contactNumber}</div>
                    <a href={`tel:${BM?.Mobile?.split("-").join("")}`} className="justify-self-end">{BM?.Mobile}</a>
                </div>
            </div>
            <div className="font-bold mt-4 text-black border-t border-r border-l bg-gray-300 p-3 rounded-t-lg fs-32w">{labels.croTitle}</div>
            <div className="p-4 rounded-tl-none rounded-tr-none rounded-b-lg border-2 border-gray-300 fs-30w">
                <div className="grid grid-cols-2 gap-2">
                    <div>{labels.croName}</div>
                    <div className="text-end">{CRO?.Name}</div>
                    <div>{labels.contactNumber}</div>
                    <a href={`tel:${CRO?.Mobile?.split("-").join("")}`} className="justify-self-end">{CRO?.Mobile}</a>
                </div>
            </div>
        </>
    );
}

export default Contact;
